import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDownloadURL, getStorage, ref } from "firebase/storage";
import { getFirestore, getDocs, collection, query, QueryConstraint, doc, getDoc } from "firebase/firestore";


const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const db = getFirestore(app);




export async function firestoreQuery<T>(collectionName: string, constrains?: QueryConstraint[]) {
  try {
    const ref = collection(db, collectionName);

    const q = query(ref, ...(constrains || []));
    const resp = await getDocs(q);
    const result: T[] = [];

    for (const doc of resp.docs) {
      const item = doc.data() as T;
      result.push(item);
    }

    return {
      list: result,
      cursor: resp.docs.length > 0 ? resp.docs[ resp.docs.length - 1 ] : null
    };
  }
  catch (e) {
    console.error(e);
    return {
      list: [],
      cursor: null
    };
  }
}


export async function firestorGetDoc<T>(collectionName: string, path: string[]) {
  try {
    const ref = doc(db, collectionName, ...path);
    const resp = await getDoc(ref);

    if (!resp.exists) {
      return null;
    }

    return resp.data() as T;
  }
  catch (e) {
    console.error(e);
    return null;
  }
}

const urlCache: { [ src: string ]: string } = {};

export const getDownloadUrl = async (src: string) => {
  try {
    if (urlCache[ src ]) {
      return urlCache[ src ];
    }

    const pathRef = ref(storage, src);
    const downloadUrl = await getDownloadURL(pathRef);
    urlCache[ src ] = downloadUrl;
    return downloadUrl;
  }
  catch (e) {
    return null;
  }

}